import { HTTP } from '@/utils/http';
import * as actions from '../types/actions';
import * as getters from '../types/getters';
import * as mutations from '../types/mutations';

export default {
  actions: {
    [actions.DO_GET_PAGES]({ commit }, params) {
      return HTTP.get('/pages', {
        params,
      })
        .then(({ data }) => {
          const pages = data.data.pages;
          commit(mutations.SET_PAGE_LIST, pages);
          if (pages.length > 0) {
            commit(mutations.SET_PAGE, pages[0]);
          }
          return pages;
        });
    },
    [actions.DO_GET_PAGE]({ commit }, params) {
      return HTTP.get(`/pages/${params.id}`, {
        params,
      })
        .then(({ data }) => {
          commit(mutations.SET_PAGE, data.data.pages[0]);
        });
    },
    [actions.DO_UPDATE_PAGE]({ commit }, params) {
      return HTTP.patch(`/pages/${params.id}`, params)
        .then(({ data }) => {
          commit(mutations.SET_PAGE, data.data.pages[0]);
          return data;
        });
    },
  },
  getters: {
    [getters.GET_PAGE]: state => state.page,
    [getters.GET_PAGES]: state => state.pages,
  },
  mutations: {
    [mutations.SET_PAGE](state, page) {
      state.page = page;
    },
    [mutations.SET_PAGE_LIST](state, pages) {
      state.pages = pages;
    },
    [mutations.SET_PAGE_FIELD](state, params) {
      state.page = Object.assign({}, state.page, params);
    },
  },
  state: {
    pages: [],
    page: {},
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/page.js